import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { isMobile } from '../utils/utils'
import { persist, createJSONStorage } from 'zustand/middleware'

export const COLOR_VISION_MG = 'mg'
export const COLOR_VISION_ME = 'me'
export const COLOR_VISION_GROUPS = 'groups'

export const COLOR_VISION = {
  MG: { id: COLOR_VISION_MG, text: 'Couleur des MGs' },
  ME: { id: COLOR_VISION_ME, text: 'Ma couleur' },
  GROUPS: { id: COLOR_VISION_GROUPS, text: 'Couleur des groupes' },
}

const isOnMobile = isMobile()

const store = (set) => ({
  colorVision: COLOR_VISION.GROUPS.id,
  printGroups: isOnMobile ? false : true,
  setColorVision: (nextColorVision) => set({ colorVision: nextColorVision }),
  setPrintGroups: (nextPrint) => set({ printGroups: nextPrint }),
})

export const useDayViewSettingsStore = create(
  persist(immer(store), {
    name: 'dayView-settings',
    storage: createJSONStorage(() => localStorage),
  })
)
